/*
 * Interface strings, Turkish.
 *
 * The "ui" bucket: everything outside the calculators. Every language the
 * picker offers has a full file here, so no English leaks into a translated
 * interface. Calculator text lives in i18n/calc, which is English and Spanish
 * only. Legal and disclaimer text is in neither: it stays English everywhere,
 * with legal.englishGoverning beside it.
 *
 * Plural keys end _one/_other and are chosen by Intl.PluralRules for this
 * language; Chinese, Thai, Vietnamese and Indonesian have one form, so they
 * carry only _other and every count lands there.
 */

/* NOT REVIEWED BY A NATIVE SPEAKER. */

const strings = {
  "landing.lead": "Devam etmek için AquaNetica hesabınızla giriş yapın.",
  "landing.signIn": "Giriş yap",
  "landing.signUpFree": "Kayıt olmak ücretsizdir.",
  "common.close": "Kapat",
  "common.cancel": "Vazgeç",
  "profile.title": "Sistem profili · {name}",
  "profile.subtitle": "Gia bu bilgilerle bu projedeki her yanıtı ayarlar. İlgisiz alanları boş bırakın.",
  "profile.species": "Tür",
  "profile.speciesPlaceholder": "örn. Atlantik somonu",
  "profile.systemType": "Sistem tipi",
  "profile.select": "Seçin…",
  "profile.sys.ras": "RAS (kapalı devre)",
  "profile.sys.flow": "Akış esaslı",
  "profile.sys.pond": "Havuz",
  "profile.sys.cage": "Ağ kafes",
  "profile.sys.hatchery": "Kuluçkahane",
  "profile.sys.other": "Diğer",
  "profile.volume": "Toplam hacim (L)",
  "profile.temp": "Hedef sıcaklık (°C)",
  "profile.lifeStage": "Yaşam evresi",
  "profile.lifeStagePlaceholder": "smolt, genç balık, anaç",
  "profile.location": "Konum",
  "profile.locationPlaceholder": "örn. Muğla, TR",
  "profile.notes": "Ek notlar",
  "profile.notesPlaceholder": "Gia'nın bu sistem hakkında bilmesi gereken diğer bilgiler",
  "profile.save": "Profili kaydet",
  "help.title": "Hakkında ve yasal uyarı",
  "help.about": "Gia, su ürünleri yetiştiricileri için hazırlanmış, mühendislik hesaplayıcıları yerleşik bir yapay zekâ asistanıdır. Sistemleri, su kalitesini ve ekipmanı değerlendirmenize yardımcı olmak için referans belgelerden ve genel bilgiden yanıt verir.",
  "legal.englishGoverning": "Koşullar ve yasal uyarı İngilizce olarak sunulur. Geçerli olan sürüm İngilizce sürümdür.",
  "feature.notNow": "Şimdi değil",
  "feature.seePlans": "Planları gör",
  "lang.title": "Dil",
  "lang.sub": "Arayüz dilini ve hangi dilde yazarsanız yazın Gia'nın yanıtladığı dili belirler.",
  "lang.auto": "Otomatik (tarayıcıma ve soruma göre)",
  "pe.timeline.ASAP": "En kısa sürede",
  "pe.timeline.1–3 months": "1–3 ay",
  "pe.timeline.Just researching": "Sadece araştırıyorum",
  "pe.condition.New": "Sıfır",
  "pe.condition.Used": "İkinci el",
  "pe.condition.Either": "Fark etmez",
  "pe.missing.quantity": "kaç adet gerektiğini",
  "pe.missing.city": "nereye gideceğini",
  "pe.missing.date": "ne zaman gerektiğini",
  "pe.nudge": "Tedarikçiler genellikle {list} bilmeden fiyat veremez. Yine de gönderebilirsiniz.",
  "pe.err.name": "Kime yanıt vereceğimizi bilmemiz için adınızı yazın.",
  "pe.err.email": "Size yanıt verebilmemiz için e-posta adresinizi yazın.",
  "pe.err.emailInvalid": "Bu e-posta doğru görünmüyor, lütfen kontrol edin.",
  "pe.err.quantity": "Kaç adet gerektiğini yazın.",
  "pe.err.city": "Teslimat şehrini yazın.",
  "pe.err.send": "Talebinizi gönderemedik. Lütfen tekrar deneyin.",
  "pe.err.network": "Sunucuya ulaşamadık. Bağlantınızı kontrol edip tekrar deneyin.",
  "pe.title": "Bunu bulmama yardım edin",
  "pe.thanks": "Teşekkürler. Size {email} adresinden döneceğiz.",
  "pe.done": "Tamam",
  "pe.whatYouNeed": "İhtiyacınız olan",
  "pe.equipment": "Ekipman",
  "pe.suggestedModels": "Önerilen modeller:",
  "pe.hideDetails": "Ayrıntıları gizle",
  "pe.editDetails": "Ayrıntıları düzenle",
  "pe.item": "İhtiyacınız olan ürün",
  "pe.specs": "Ayrıntılar ve kapasite",
  "pe.name": "Adınız",
  "pe.email": "E-posta (yanıt verebilmemiz için)",
  "pe.when": "Ne zaman gerekiyor?",
  "pe.quantity": "Kaç adet gerekiyor?",
  "pe.quantityPlaceholder": "örn. 2 adet",
  "pe.city": "Teslimat şehri",
  "pe.cityPlaceholder": "Nereye teslim edilecek?",
  "pe.neededBy": "Son teslim tarihi (isteğe bağlı)",
  "pe.condition": "Sıfır mı ikinci el mi? (isteğe bağlı)",
  "pe.budget": "Yaklaşık bütçe (isteğe bağlı)",
  "pe.amount": "Tutar",
  "pe.budgetAmount": "Bütçe tutarı",
  "pe.budgetCurrency": "Bütçe para birimi",
  "pe.notSure": "Emin değilim",
  "pe.note": "Başka bir şey var mı? (isteğe bağlı)",
  "pe.notePlaceholder": "Doğru ürünü bulmamıza yardımcı olacak diğer bilgiler.",
  "pe.hideFarm": "Çiftlik bilgilerini gizle",
  "pe.addFarm": "Çiftlik bilgilerini ekle (isteğe bağlı)",
  "pe.farm": "Çiftlik veya firma adı",
  "pe.country": "Ülke",
  "pe.sending": "Gönderiliyor…",
  "pe.send": "Talebi gönder",
  "pe.reassurance": "Hiçbir yükümlülük yok. AquaNetica'dan bir kişi e-posta ile dönecek.",
  "toolbar.answerLanguage": "Dil: {name}",
  "toolbar.answerLanguageTitle": "Dil",
  "project.namePrompt": "Proje adı?",
  "project.renamePrompt": "Projeyi yeniden adlandır:",
  "project.deleteWithChats": "\"{name}\" projesi ve {count} sohbeti silinsin mi?",
  "project.deleteWithChats_one": "\"{name}\" projesi ve {count} sohbeti silinsin mi?",
  "project.deleteWithChats_other": "\"{name}\" projesi ve {count} sohbeti silinsin mi?",
  "project.delete": "\"{name}\" projesi silinsin mi?",
  "file.proTitle": "Dosyalı mesajlar Pro özelliğidir",
  "file.proMessage": "Planınız dosyalı mesajları kapsamıyor. Teknik föy, çizim ve fotoğrafları Gia'nın okuyabilmesi için Pro'ya geçin. Dosya ekliyken gönderdiğiniz her mesaj bir dosyalı mesaj sayılır.",
  "file.badType": "Lütfen bir görsel (JPG, PNG, GIF, WEBP), PDF, Word, Excel veya PowerPoint dosyası (.docx, .xlsx, .pptx) ya da bir metin veya kod dosyası (.txt, .md, .csv, .json, .r, .py) ekleyin.",
  "file.tooLarge": "Dosya çok büyük. Ekler 20 MB'ın altında olmalı.",
  "file.unreadable": "Gia bu dosyayı okuyamadı. Dosya parola korumalıysa ya da eski bir .doc, .xls veya .ppt dosyasıysa, parolasız .docx, .xlsx veya .pptx olarak kaydedip yeniden ekleyin.",
  "file.noText": "Bu dosyada Gia'nın okuyabileceği metin yok. Taranmış bir belge ya da çoğunlukla görselse, PDF veya görsel olarak ekleyin.",
  "file.tooBig": "Bu dosya Gia'nın tek seferde okuyamayacağı kadar büyük. Daha küçük dosyalara bölün ya da yalnızca gereken bölümü ekleyin.",
  "file.notText": "Bu dosya, adı öyle gösterse de düz metin değil. Metin (UTF-8) olarak kaydedip yeniden ekleyin.",
  "chat.errSomething": "Üzgünüm, bir şeyler ters gitti: {detail}",
  "chat.errNoBackend": "Üzgünüm, bilgi tabanına ulaşamadım. Arka ucun 3001 portunda çalıştığını kontrol edin.",
  "file.attached": "· bu sohbete eklendi",
  "file.left": "Bu ay {count} dosyalı mesaj kaldı",
  "file.left_one": "Bu ay {count} dosyalı mesaj kaldı",
  "file.left_other": "Bu ay {count} dosyalı mesaj kaldı",
  "file.detachTitle": "Dosyayı kaldır: dosyalı mesaj hakkınızdan düşmeyi bırakır",
  "file.detachLabel": "Dosyayı kaldır",
  "file.detach": "Kaldır",
  "file.explain": "Bu dosya ekliyken gönderdiğiniz her mesaj bir dosyalı mesaj sayılır. Gia'nın artık bakması gerekmiyorsa dosyayı kaldırın.",
  "file.reattachHint": "{name}: sormaya devam etmek için yeniden ekleyin",
  "file.reattachTitle": "Dosyayı yeniden ekle",
  "file.reattach": "Yeniden ekle",
  "usage.questions": "Bu ay {limit} sorudan {left} tanesi kaldı",
  "usage.questions_one": "Bu ay {limit} sorudan {left} tanesi kaldı",
  "usage.questions_other": "Bu ay {limit} sorudan {left} tanesi kaldı",
  "usage.questionsShort": "{left}/{limit} soru kaldı",
  "usage.questionsShort_one": "{left}/{limit} soru kaldı",
  "usage.questionsShort_other": "{left}/{limit} soru kaldı",
  "usage.files": "{limit} dosyalı mesajdan {left} tanesi kaldı",
  "usage.files_one": "{limit} dosyalı mesajdan {left} tanesi kaldı",
  "usage.files_other": "{limit} dosyalı mesajdan {left} tanesi kaldı",
  "usage.leftShort": "{left} soru kaldı",
  "usage.leftShort_one": "{left} soru kaldı",
  "usage.leftShort_other": "{left} soru kaldı",
  "usage.remaining": "{left} / {limit} soru kaldı",
  "usage.remaining_one": "{left} / {limit} soru kaldı",
  "usage.remaining_other": "{left} / {limit} soru kaldı",
  "usage.upgrade": "Yükselt",
  "wall.daily": "Bugünkü mesaj sınırına ulaştınız",
  "wall.feature": "{plan} planı bunu kapsamıyor",
  "wall.featureYour": "Planınız bunu kapsamıyor",
  "wall.files": "Bu ay {plan} planınızdaki {limit} dosyalı mesajın tamamını kullandınız",
  "wall.questions": "Bu ay {plan} planınızdaki {limit} sorunun tamamını kullandınız",
  "wall.generic": "Planınızdaki bir sınıra ulaştınız",
  "wall.region": "Soru sınırına ulaşıldı",
  "wall.refresh": "{plan} planınızdaki sorular her ayın 1'inde yenilenir.",
  "wall.refreshNoPlan": "Sorularınız her ayın 1'inde yenilenir.",
  "wall.stayFree": "Hesaplayıcılar ücretsiz ve sınırsız kalır, geçmiş sohbetlerinizin tamamı okumak için burada durur.",
  "wall.upgrade": "aquanetica.com üzerinden yükseltin",
  "sidebar.hide": "Kenar çubuğunu gizle",
  "sidebar.search": "Sohbetlerde ara…",
  "sidebar.newChat": "+ Yeni sohbet",
  "sidebar.newProject": "+ Proje",
  "sidebar.tools": "🛠️ Araçlar",
  "sidebar.backToGia": "Gia'ya dön",
  "sidebar.calculator": "Hesaplayıcı",
  "sidebar.empty": "Henüz sohbet yok. Başlamak için Gia'ya bir şey sorun.",
  "sidebar.profileSet": "Sistem profili tanımlı",
  "sidebar.newInProject": "Bu projede yeni sohbet",
  "sidebar.editProfile": "Profili düzenle",
  "sidebar.rename": "Yeniden adlandır",
  "sidebar.delete": "Sil",
  "sidebar.projectEmpty": "Henüz sohbet yok",
  "sidebar.noMatches": "\"{q}\" için sonuç yok",
  "sidebar.signedIn": "Oturum açık",
  "sidebar.signOut": "Çıkış yap",
  "sidebar.signingOut": "Çıkış yapılıyor…",
  "signout.title": "Çıkış yap",
  "signout.body": "AquaNetica IQ ve aquanetica.com oturumlarınız kapatılacak. Yüklenen belgeler ve yanıt değerlendirmeleri bu cihazdan her zaman silinir. Kaydettiğiniz diğer her şey, yeniden giriş yaptığınızda burada olur.",
  "signout.alsoClear": "Bu cihazdaki kayıtlı çalışmalarımı da sil: sohbetler, projeler ve hesaplamalar",
  "signout.irreversible": "Bu ek silme kalıcıdır. Bu çalışma yalnızca bu tarayıcıda saklanır, geri yüklenecek bir kopya yoktur.",
  "signout.confirm": "Çıkış yap",
  "sidebar.communityTitle": "AquaNetica topluluğuna dön (yeni sekmede açılır)",
  "sidebar.community": "AquaNetica'ya dön",
  "sidebar.help": "Yardım ve yasal uyarı",
  "drop.label": "Eklemek için dosyayı bırakın",
  "toolbar.showSidebar": "Kenar çubuğunu göster",
  "toolbar.toggleSidebar": "Kenar çubuğunu aç/kapat",
  "toolbar.newChat": "Yeni sohbet",
  "toolbar.inProject": "Proje:",
  "toolbar.home": "AquaNetica topluluğuna dön",
  "toolbar.homeTitle": "AquaNetica'ya dön (yeni sekmede açılır)",
  "toolbar.calc": "Hesaplayıcıyı aç",
  "toolbar.theme": "Temayı değiştir",
  "hero.title": "Size nasıl yardımcı olabilirim?",
  "hero.calibrated": "Gia, bu projenin sistem profiline göre ayarlandı.",
  "hero.noProfile": "Henüz sistem profili yok. Oluşturmak için projedeki ⚙ simgesine tıklayın.",
  "hero.subtitle": "Su ürünleri sistemleri, su kalitesi veya ekipman hakkında her şeyi sorabilirsiniz.",
  "composer.attachTitle": "Görsel veya PDF ekle",
  "composer.attachLabel": "Dosya ekle",
  "composer.send": "Gönder",
  "answer.copyTitle": "Yanıtı kopyala",
  "answer.copied": "Kopyalandı",
  "answer.copy": "Kopyala",
  "answer.retryTitle": "Bu soruyu tekrar sor",
  "answer.retryLabel": "Yanıtı yenile",
  "answer.retry": "Tekrar dene",
  "answer.good": "İyi yanıt",
  "answer.bad": "Kötü yanıt",
  "answer.sourcing": "Bunu bulmak için yardım ister misiniz? →",
  "answer.searching": "Belge kitaplığı taranıyor…",
  "answer.scrollLatest": "En sona git",
  "sidebar.otherChats": "Diğer",
  "trial.have": "Kodunuz var mı?",
  "trial.title": "Deneme kodu",
  "trial.placeholder": "Deneme kodunuzu girin",
  "trial.submit": "Kullan",
  "trial.checking": "Kontrol ediliyor…",
  "trial.invalid": "Bu kod geçerli değil. Kontrol edip tekrar deneyin.",
  "trial.error": "Bu kodu kontrol edemedik. Lütfen tekrar deneyin.",
  "trial.success": "Pro denemesi başladı. {date} tarihine kadar ayda 75 soru ve 10 dosyalı mesaj hakkınız var.",
  "trial.active": "Pro denemesi: {date}",
  "sidebar.planTrial": "{plan} denemesi",
  "sidebar.managePlan": "Planı yönet",
  "trial.ends": "Deneme {date} tarihinde bitiyor",
  "pe.consent": "Talep bilgilerimin AquaNetica ile ve benim adıma başvurulan tedarikçilerle paylaşılmasını, ayrıca {terms} ve {privacy} hükümlerini kabul ediyorum.",
  "pe.consentTerms": "Hizmet Şartları",
  "pe.consentPrivacy": "Gizlilik Politikası",
};

export default strings;
